import { render, staticRenderFns } from "./KintaiCardHoliday.vue?vue&type=template&id=0c9ae51c&"
import script from "./KintaiCardHoliday.vue?vue&type=script&lang=ts&"
export * from "./KintaiCardHoliday.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports